module.exports = __webpack_public_path__ + "img/icon_num_bf.ecb4ef80.png";